import React, { useState, useEffect } from "react";
import styles from "./LearnMoreBanner.module.css";
import Button from "./button.js";
import youtubeImage from "../../../assets/images/presentation-border.svg";
import downloadImage from "../../../assets/images/Download-white.svg";
import factsheetIconWhite from "../../../assets/images/factsheetIconWhite.svg";
import { IMAGE_URL, SITE_ID } from "../../../services/apiConstants";
import { downloadPdf } from "../../../utils/downloadPdf";

export default function LearnMoreBanner({
  image,
  title,
  subTitle,
  presentation,
  factSheet,
  titleFlag,
}) {
  const [isOnhoverPresentationBtn, setIsOnhoverPresentationBtn] =
    useState(false);
  const [isOnhoverFactsheetBtn, setIsOnhoverFactsheetBtn] = useState(false);
  const [isClickedPresentationBtn, setIsClickedPresentationBtn] =
    useState(false);
  const [isClickedFactsheetBtn, setIsClickedFactsheetBtn] = useState(false);

  const onClick = async (name, urlPdf) => {
    const url = IMAGE_URL + urlPdf + SITE_ID;
    switch (name) {
      case "presentationBtn":
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "PMSpresentation_Download",
          inquiryType: "",
          buttonName: "Presentations",
          email: "", // Encrypted email of the User using SHA-256 encryption
          contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
          clientID: "",
          queryMessage: "",
          state: "",
          pageSection: "",
          Category: urlPdf?.split("/").pop().split(".")[0],
          FAQ: "",
        });
        return downloadPdf(url, urlPdf?.split("/").pop().split(".")[0]);
      case "factsheetBtn":
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "PMSfactsheet_download",
          inquiryType: "",
          buttonName: "Factsheet",
          email: "", // Encrypted email of the User using SHA-256 encryption
          contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
          clientID: "",
          queryMessage: "",
          state: "",
          pageSection: "",
          Category: urlPdf?.split("/").pop().split(".")[0],
          FAQ: "",
        });
        return downloadPdf(url, urlPdf?.split("/").pop().split(".")[0]);
      default:
        return;
    }
  };
  const onMouseHoverPresentationsBtn = () => {
    setIsOnhoverPresentationBtn(true);
  };
  const onMouseLeavePresentationsBtn = () => {
    setIsOnhoverPresentationBtn(false);
  };

  const onMouseHoverFactsheetBtn = () => {
    setIsOnhoverFactsheetBtn(true);
  };
  const onMouseLeaveFactsheetBtn = () => {
    setIsOnhoverFactsheetBtn(false);
  };

  useEffect(() => {
    document.getElementById("sectionTagId").style.backgroundImage = `url(${
      IMAGE_URL + image + SITE_ID
    })`;
  });
  return (
    <>
      <section id="sectionTagId" className={styles.contraImageBanner}>
        {titleFlag && (
          <>
            <p className={styles.bannerTitle}>{title}</p>
            <p className={styles.bannerSubTitle}>{subTitle}</p>
          </>
        )}
        <div className={styles.buttonsView}>
          <Button
            urlPdf={presentation?.item[0].value}
            id="presentationBtn"
            onClick={onClick}
            isClicked={isClickedPresentationBtn}
            imgSrc={
              isOnhoverPresentationBtn || isClickedPresentationBtn
                ? downloadImage
                : youtubeImage
            }
            text={isOnhoverPresentationBtn ? "Download" : "Presentation"}
            onMouseHover={onMouseHoverPresentationsBtn}
            onMouseLeave={onMouseLeavePresentationsBtn}
          />
          <Button
            urlPdf={factSheet?.item[0].value}
            isClicked={isClickedFactsheetBtn}
            id="factsheetBtn"
            onClick={onClick}
            imgSrc={
              isOnhoverFactsheetBtn || isClickedFactsheetBtn
                ? downloadImage
                : factsheetIconWhite
            }
            text={isOnhoverFactsheetBtn ? "Download" : "Factsheet"}
            onMouseHover={onMouseHoverFactsheetBtn}
            onMouseLeave={onMouseLeaveFactsheetBtn}
          />
        </div>
      </section>
    </>
  );
}
